
import React, { useState } from 'react';
import HeadToHeadHeader from './head-to-head/HeadToHeadHeader';
import HeadToHeadStats from './head-to-head/HeadToHeadStats';
import TeamFormSection from './head-to-head/TeamFormSection';
import MatchList from './head-to-head/MatchList';
import MatchFilter from './head-to-head/components/MatchFilter';
import { calculateTeamStats } from './head-to-head/utils/statsCalculator';
import { Match } from './types/head-to-head';
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";

interface HeadToHeadResultsProps {
  matches: Match[];
  homeTeam: string;
  awayTeam: string;
}

const HeadToHeadResults: React.FC<HeadToHeadResultsProps> = ({
  matches,
  homeTeam,
  awayTeam
}) => {
  const [showHomeAwayOnly, setShowHomeAwayOnly] = useState(false);
  const [showMatches, setShowMatches] = useState(true);
  const [selectedMatchIndex, setSelectedMatchIndex] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState(true);

  const h2hMatches = matches.filter(match => {
    const isValidMatch = match.HomeTeam === homeTeam && match.AwayTeam === awayTeam || match.HomeTeam === awayTeam && match.AwayTeam === homeTeam;
    if (showHomeAwayOnly) {
      return match.HomeTeam === homeTeam && match.AwayTeam === awayTeam;
    }
    return isValidMatch;
  });

  return (
    <div className="space-y-8">
      <div className="mt-8">
        <Collapsible open={isOpen} onOpenChange={setIsOpen}>
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-4">
              <MatchFilter 
                showHomeAwayOnly={showHomeAwayOnly} 
                setShowHomeAwayOnly={setShowHomeAwayOnly}
                homeTeam={homeTeam}
                awayTeam={awayTeam}
              />
            </div>
            <div className="flex-grow text-center">
            </div>
            <div className="flex items-center gap-4">
              <CollapsibleTrigger asChild>
                <Button variant="ghost" size="sm" className="gap-2">
                  <span>{isOpen ? 'Hide' : 'Show'}</span>
                  {isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
                </Button>
              </CollapsibleTrigger>
            </div>
          </div>

          <CollapsibleContent>
            <HeadToHeadHeader 
              showHomeAwayOnly={showHomeAwayOnly} 
              setShowHomeAwayOnly={setShowHomeAwayOnly} 
            />

            <TeamFormSection 
              homeTeam={homeTeam} 
              awayTeam={awayTeam} 
              matches={h2hMatches}
              selectedMatchIndex={selectedMatchIndex} 
              setSelectedMatchIndex={setSelectedMatchIndex}
            />

            <MatchList 
              showMatches={showMatches} 
              setShowMatches={setShowMatches} 
              matches={h2hMatches} 
              selectedMatchIndex={selectedMatchIndex} 
            />

            <HeadToHeadStats 
              homeTeamStats={calculateTeamStats(h2hMatches, homeTeam)} 
              awayTeamStats={calculateTeamStats(h2hMatches, awayTeam)} 
              homeTeam={homeTeam} 
              awayTeam={awayTeam} 
              matches={h2hMatches} 
            />
          </CollapsibleContent>
        </Collapsible>
      </div>
    </div>
  );
};

export default HeadToHeadResults;
